var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3495_32521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0393 12.3321L17.3752 11.3711C17.5432 10.4649 17.5432 9.53519 17.3752 8.62894L19.0393 7.668C19.2307 7.55863 19.3166 7.33207 19.2541 7.12113C18.8206 5.7305 18.0823 4.47269 17.1174 3.42582C16.969 3.26566 16.7268 3.2266 16.5393 3.33597L14.8752 4.29691C14.176 3.69535 13.3713 3.23051 12.5002 2.92582V1.00785C12.5002 0.789099 12.3479 0.597693 12.1331 0.550818C10.6995 0.230505 9.23071 0.24613 7.86743 0.550818C7.65258 0.597693 7.50024 0.789099 7.50024 1.00785V2.92972C6.63305 3.23832 5.82836 3.70316 5.12524 4.30082L3.46508 3.33988C3.27368 3.23051 3.0354 3.26566 2.88696 3.42972C1.92211 4.47269 1.18383 5.7305 0.750239 7.12504C0.683833 7.33597 0.773677 7.56254 0.965083 7.67191L2.62915 8.63285C2.46118 9.5391 2.46118 10.4688 2.62915 11.375L0.965083 12.336C0.773677 12.4453 0.687739 12.6719 0.750239 12.8828C1.18383 14.2735 1.92211 15.5313 2.88696 16.5782C3.0354 16.7383 3.27758 16.7774 3.46508 16.668L5.12915 15.7071C5.82836 16.3086 6.63305 16.7735 7.50415 17.0782V19C7.50415 19.2188 7.65649 19.4102 7.87133 19.4571C9.30493 19.7774 10.7737 19.7618 12.137 19.4571C12.3518 19.4102 12.5041 19.2188 12.5041 19V17.0782C13.3713 16.7696 14.176 16.3047 14.8791 15.7071L16.5432 16.668C16.7346 16.7774 16.9729 16.7422 17.1213 16.5782C18.0862 15.5352 18.8245 14.2774 19.2581 12.8828C19.3166 12.668 19.2307 12.4414 19.0393 12.3321ZM10.0002 13.125C8.27758 13.125 6.87524 11.7227 6.87524 10C6.87524 8.27738 8.27758 6.87504 10.0002 6.87504C11.7229 6.87504 13.1252 8.27738 13.1252 10C13.1252 11.7227 11.7229 13.125 10.0002 13.125Z",
    fill: "#DDDDDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3495_32521",
    x: 0,
    y: 0,
    width: 20,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3495_32521"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.11f4dcea112a794df0ef1ccc7b67f7dc.svg";
export { ForwardRef as ReactComponent };